import { InfoCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React, { CSSProperties } from "react";
import { ButtonGroup, ButtonGroupProps } from "../Button/ButtonGroup";

type ApprovalBarProps = {
  isVisible?: boolean;
  message: React.ReactNode;
  primaryButton: ButtonGroupProps["primaryButton"];
  secondaryButton: ButtonGroupProps["secondaryButton"];
  showIcon?: boolean;
  icon?: React.ReactNode;
  containerStyle?: React.CSSProperties;
  messageStyle?: React.CSSProperties;
};

export const ApprovalBar = (props: ApprovalBarProps) => {
  const {
    isVisible = true,
    message,
    primaryButton,
    secondaryButton,
    showIcon = true,
    icon,
    containerStyle,
    messageStyle,
  } = props;

  if (!isVisible) return null;

  const resolvedIcon = icon ?? <InfoCircleOutlined />;

  const defaultContainerStyle: CSSProperties = {
    width: "100%",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "10px 14px",
    borderRadius: 8,
    border: `1px solid var(--cyan-300)`,
    background: "var(--cyan-100)",
    ...containerStyle,
  };

  const defaultMessageStyle: CSSProperties = {
    color: "var(--cyan-600)",
    fontSize: 13,
    lineHeight: "18px",
    minWidth: 0,
    flex: 1,
    ...messageStyle,
  };

  return (
    <div style={defaultContainerStyle}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0, flex: 1 }}>
        {showIcon ? <span style={{ color: "var(--cyan-600)" }}>{resolvedIcon}</span> : null}
        <Typography.Text ellipsis style={defaultMessageStyle}>
          {message}
        </Typography.Text>
      </div>

      <ButtonGroup
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        style={{ width: "auto", flexShrink: 0, flexDirection: "row-reverse" }}
      />
    </div>
  );
};
